/**
 * useHelpForRoute — henter relevante hjelpe-artikler for nåværende rute.
 * Rute hentes fra react-router useLocation.
 */
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getArticlesForRoute, type HelpArticleListItem, type HelpLanguage } from '../lib/help';

export function useHelpForRoute(language: HelpLanguage = 'nb'): {
  articles: HelpArticleListItem[];
  loading: boolean;
  route: string;
} {
  const location = useLocation();
  const [articles, setArticles] = useState<HelpArticleListItem[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    getArticlesForRoute(location.pathname, language)
      .then(list => { if (!cancelled) setArticles(list); })
      .catch(() => { if (!cancelled) setArticles([]); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [location.pathname, language]);

  return { articles, loading, route: location.pathname };
}
